export const getAuthToken = () => {
    return sessionStorage.getItem("token") || ""; // Fallback to empty string if token is missing
  };
  
  export const getAuthHeaders = () => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${getAuthToken()}`,
    };
  };
  